document.addEventListener('DOMContentLoaded', function () {
  var bar = document.getElementById('StickyBuyBar');
  if (!bar) return;

  var buyBox = document.querySelector('.product-block--buy-buttons, .product-single__form, .product-form, [data-product-form]');
  var priceEl = document.getElementById('StickyBuyBarPrice');
  var optionsEl = document.getElementById('StickyBuyBarOptions');
  var priceSource = document.querySelector('.product-block--price .product__price, .product__price');
  var productTitle = bar.getAttribute('data-product-title') || '';

  function currentAddButton() {
    return document.querySelector('.product-single__form [data-add-to-cart], .product-single__form button[name="add"], form[action*="/cart/add"] [data-add-to-cart]');
  }

  function currentForm() {
    var button = currentAddButton();
    return (button && button.form) || document.querySelector('.product-single__form');
  }

  var ticking = false;
  function checkScroll() {
    if (!buyBox) return;
    var boxBottom = buyBox.getBoundingClientRect().bottom;
    if (boxBottom < 0) {
      bar.hidden = false;
      bar.classList.add('is-visible');
    } else {
      bar.classList.remove('is-visible');
    }
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          checkScroll();
          ticking = false;
        });
        ticking = true;
      }
    },
    { passive: true }
  );
  checkScroll();

  function submitProductForm() {
    var form = currentForm();
    var addButton = currentAddButton();
    if (addButton && !addButton.disabled) {
      addButton.click();
      return;
    }
    if (form && typeof form.requestSubmit === 'function') {
      form.requestSubmit(addButton || undefined);
      return;
    }
    if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  function clickWallet() {
    var host = document.querySelector('.product-block--buy-buttons shopify-accelerated-checkout, .shopify-payment-button shopify-accelerated-checkout');
    if (host) {
      var walletBtn =
        (host.shadowRoot &&
          host.shadowRoot.querySelector('button, [role="button"], a')) ||
        host.querySelector('button, [role="button"], a');
      if (walletBtn) {
        walletBtn.click();
        return;
      }
      host.click();
      return;
    }
    var fallback = document.querySelector('.shopify-payment-button__button, .shopify-payment-button button');
    if (fallback) fallback.click();
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target) return;
    if (target.id === 'StickyBuyBarButton' || target.closest('#StickyBuyBarButton')) {
      e.preventDefault();
      submitProductForm();
      return;
    }
    if (target.id === 'StickyBuyBarPaypal' || target.closest('#StickyBuyBarPaypal')) {
      e.preventDefault();
      clickWallet();
    }
  });

  function selectedHandleValue(handle) {
    var wrap = document.querySelector('.variant-input-wrap[data-handle="' + handle + '"]');
    if (!wrap) return '';
    var input = wrap.querySelector('input:checked');
    return input && input.value ? String(input.value).trim() : '';
  }

  function formatOptions(variant) {
    var style = selectedHandleValue('style');
    var size = selectedHandleValue('size');
    var ordered = [style, size].filter(Boolean);
    if (ordered.length) return ordered.join(' · ');
    if (variant && variant.options && variant.options.length) {
      return variant.options.filter(Boolean).join(' · ');
    }
    if (variant && variant.title && variant.title !== 'Default Title') {
      return String(variant.title).replace(/\s+\/\s+/g, ' · ');
    }
    return '';
  }

  function syncVariant(event) {
    var variant = event && event.detail && (event.detail.variant || event.detail);
    if (!variant) return;
    if (priceEl && typeof variant.price !== 'undefined') {
      var sourceText = priceSource ? priceSource.textContent.trim() : '';
      priceEl.textContent = sourceText || variant.price;
    }
    if (optionsEl) {
      var label = formatOptions(variant);
      optionsEl.textContent = label ? ' · ' + label : '';
    }
    if (variant.featured_image && bar.querySelector('.sticky-buy-bar__image')) {
      bar.querySelector('.sticky-buy-bar__image').src = variant.featured_image.src || bar.querySelector('.sticky-buy-bar__image').src;
    }
    if (productTitle) {
      var titleEl = document.getElementById('StickyBuyBarTitle');
      if (titleEl) titleEl.textContent = productTitle;
    }
  }

  document.addEventListener('variant:change', syncVariant);
  document.addEventListener('variantChange', syncVariant);

  if (priceSource && priceEl) {
    var observer = new MutationObserver(function () {
      priceEl.textContent = priceSource.textContent.trim();
    });
    observer.observe(priceSource, { childList: true, characterData: true, subtree: true });
  }
});
